import React from "react";

const SupplierRecipientInfo = ({ data }) => {
  const countryOfSupply = data?.countryOfSupply;
  const capitalizedCountry = countryOfSupply
    ? countryOfSupply.charAt(0).toUpperCase() + countryOfSupply.slice(1)
    : "";
  return (
    <div>
      <h1 style={{ textAlign: "center" }}>
        {data?.invoiceType?.toUpperCase()}
      </h1>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ maxWidth: "50%" }}>
          <p>
            Business Firm/ Person Name:{" "}
            <b>{data?.businessName || data?.contactPersonName}</b>
            <br /> Phone: <b>{data?.phoneNumber || "N/A"}</b>
            <br /> Address: <b>{data?.address || "N/A"}</b>
            <br />
            GSTIN: <b>{data?.gstNumber || "N/A"}</b>
          </p>
        </div>
        <div style={{ margin: "auto" }}>
          <p>
            {data?.invoiceType === "estimate"
              ? "Estimate Number"
              : data?.invoiceType === "credit note"
              ? "CN Number"
              : "Invoice Number"}
            :{" "}
            <b>
              {data?.invoiceType === "credit note"
                ? data?.manualCNNumber || data?.creditNoteNumber
                : data?.manualInvoiceNumber || data?.invoiceNumber}
            </b>{" "}
            <br />
            Date: <b>{data?.invoiceDate}</b> <br />
            Place of Supply: <b>{data?.billingAddress?.state || "N/A"}</b>
            <br />
            Country of Supply: <b>{capitalizedCountry}</b> <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupplierRecipientInfo;
